<script>
import CockpitLineVerticalSelector
from '@/components/cockpit/lineSelector/CockpitLineVerticalSelector.vue';
import CockpitActiveOrderCard from '@/components/cockpit/activeOrder/CockpitActiveOrderCard.vue';
import CockpitMatryoshka from '@/components/cockpit/matryoshka/CockpitMatryoshka.vue';
import CockpitOffcanvas from '@/components/cockpit/CockpitOffcanvas.vue';
import CockpitActiveOrderDetailsTab
from '@/components/cockpit/activeOrder/offcanvas/tabs/CockpitActiveOrderDetailsTab.vue';
import CockpitActiveOrderHistoryTab
from '@/components/cockpit/activeOrder/offcanvas/tabs/CockpitActiveOrderHistoryTab.vue';
import CockpitMatryoshkaItemActionButtons
from '@/components/cockpit/matryoshka/offcanvas/CockpitMatryoshkaItemActionButtons.vue';
import CockpitMatryoshkaItemDetailsTab
from '@/components/cockpit/matryoshka/offcanvas/tabs/CockpitMatryoshkaItemDetailsTab.vue';
import CockpitMatryoshkaItemContentsTab
from '@/components/cockpit/matryoshka/offcanvas/tabs/CockpitMatryoshkaItemContentsTab.vue';
import CockpitMatryoshkaItemHistoryTab
from '@/components/cockpit/matryoshka/offcanvas/tabs/CockpitMatryoshkaItemHistoryTab.vue';
import CockpitMatryoshkaItemLabelTab
from '@/components/cockpit/matryoshka/offcanvas/tabs/CockpitMatryoshkaItemLabelTab.vue';
import CockpitMatryoshkaPrintManuallyTab
from '@/components/cockpit/matryoshka/offcanvas/tabs/CockpitMatryoshkaPrintManuallyTab.vue';
import CockpitOffcanvasTypes from '@/components/cockpit/CockpitOffcanvasTypes';
import CockpitMatryoshkaItemAuditTab
from '@/components/cockpit/matryoshka/offcanvas/tabs/CockpitMatryoshkaItemAuditTab.vue';
import CockpitMatryoshkaItemOperationsTab
from '@/components/cockpit/matryoshka/offcanvas/tabs/CockpitMatryoshkaItemOperationsTab.vue';
import { mapActions, mapGetters } from 'vuex';
import LabelArchiveMatrix from '@/components/dev/LabelArchiveMatrix.vue';
import PrintBatchesModal from '../components/cockpit/PrintBatchesModal.vue';

export default {
  name: 'Cockpit',
  data: () => ({
    initLoading: false,
    linesCollapsed: true,
    selectedLineId: 0,
    selectedLabelArchiveId: 0,
    offcanvasTabIndex: 0,
    offcanvasVisible: false,
    showPrintBatchesModal: false,
    printBatchFormData: null,
    offcanvasData: {
      orderId: 1,
    },
    matrioshkaKey: 1,
    showLoadingOverlay: false,
    debugStatuses: [
      'Aviso',
      'Active',
      'Removed',
      'Printed',
      'QualityCheck',
      'StorageSample',
      'Exported',
      'Imported',
      'Utilized',
      'Empty',
      'ScheduledForPrint',
    ],
    CockpitOffcanvasTypes,
    loadingActiveLineOrders: false,
    activeLineOrders: [],
    scannedSerialNumber: '',
    offcanvasUnit: null,
    cockpitOrderRefreshInterval: null,
    refreshAggregationLoading: false,
  }),
  components: {
    LabelArchiveMatrix,
    CockpitMatryoshkaItemOperationsTab,
    CockpitMatryoshkaItemAuditTab,
    CockpitMatryoshkaPrintManuallyTab,
    CockpitMatryoshkaItemLabelTab,
    CockpitMatryoshkaItemHistoryTab,
    CockpitMatryoshkaItemContentsTab,
    CockpitMatryoshkaItemDetailsTab,
    CockpitMatryoshkaItemActionButtons,
    CockpitActiveOrderHistoryTab,
    CockpitActiveOrderDetailsTab,
    CockpitOffcanvas,
    CockpitMatryoshka,
    CockpitActiveOrderCard,
    CockpitLineVerticalSelector,
    PrintBatchesModal,
  },
  computed: {
    ...mapGetters([
      'defaultLineId',
    ]),
    ...mapGetters('packingSettings', [
      'getUnitById',
    ]),
    ...mapGetters([
      'globalSettings',
    ]),
    ...mapGetters('labelArchive', [
      'labelArchiveStatuses',
    ]),
    ...mapGetters('debug', ['debug']),
    allStatuses() {
      return this.labelArchiveStatuses;
    },
    offcanvasTitle() {
      switch (this.offcanvasVisible) {
        case CockpitOffcanvasTypes.ORDER_DETAILS:
          return this.$t('cockpit.orderDetails');
        case CockpitOffcanvasTypes.QUEUE_ITEM_DETAILS:
          return `${this.$t('cockpit.details')} - ${this.offcanvasUnitName}`;
        case CockpitOffcanvasTypes.PRINT_MANUALLY:
          return this.$t('cockpit.printManually');
        case CockpitOffcanvasTypes.QUEUE_ITEM_AUDIT:
          return this.$t('cockpit.audit');
        case CockpitOffcanvasTypes.QUEUE_ITEM_OPERATIONS:
          return this.$t('cockpit.availableOperations');
        default:
          return '';
      }
    },
    offcanvasIcon() {
      switch (this.offcanvasVisible) {
        case CockpitOffcanvasTypes.PRINT_MANUALLY:
          return 'fa-print';
        case CockpitOffcanvasTypes.QUEUE_ITEM_AUDIT:
          return 'fa-clock';
        default:
          return 'fa-info-circle';
      }
    },
    offcanvasTabs() {
      switch (this.offcanvasVisible) {
        case CockpitOffcanvasTypes.ORDER_DETAILS:
          return [
            this.$t('cockpit.general'),
            this.$t('cockpit.history'),
          ];
        case CockpitOffcanvasTypes.QUEUE_ITEM_DETAILS:
          return [
            this.$t('cockpit.general'),
            this.$t('cockpit.contents'),
            this.$t('cockpit.history'),
            // this.$t('cockpit.label'),
          ];
        case CockpitOffcanvasTypes.PRINT_MANUALLY:
          return [
            this.$t('cockpit.print'),
          ];
        case CockpitOffcanvasTypes.QUEUE_ITEM_AUDIT:
          return [
            this.$t('cockpit.audit'),
          ];
        case CockpitOffcanvasTypes.QUEUE_ITEM_OPERATIONS:
          return [
            this.$t('cockpit.operations'),
          ];
        default:
          return [];
      }
    },
    offcanvasUnitName() {
      return (this.getUnitById(this.offcanvasUnit)?.name || '').toUpperCase();
    },
    activeOrderId() {
      if (!this.activeLineOrders || !this.activeLineOrders.length) return 0;
      return this.activeLineOrders[0]?.order?.id || 0;
    },
  },
  watch: {
    offcanvasVisible: {
      handler() {
        this.offcanvasData = {};
        this.offcanvasTabIndex = 0;
      },
    },
    selectedLineId: {
      handler() {
        this.fetchProdOrderForSelectedLine();
      },
    },
    showPrintBatchesModal(v) {
      if (!v) {
        this.printBatchFormData = null;
      }
    },
    defaultLineId() {
      this.$router.go(0);
    },
  },
  methods: {
    ...mapActions('labelArchive', [
      'refreshAggregation',
    ]),
    ...mapActions([
      'getProdOrders',
    ]),
    ...mapActions('labelArchive', [
      'getLabelArchiveByBarcodes',
    ]),
    ...mapActions('packingSettings', [
      'getUnits',
      'getPackingSettings',
    ]),
    toggleFullscreen() {
      const doc = document;
      if (!doc.fullscreenElement
      && !doc.mozFullScreenElement
      && !doc.webkitFullscreenElement
      && !doc.msFullscreenElement) {
        const el = doc.documentElement;
        if (el.requestFullscreen) {
          el.requestFullscreen();
        } else if (el.mozRequestFullScreen) { // Firefox
          el.mozRequestFullScreen();
        } else if (el.webkitRequestFullscreen) { // Chrome, Safari and Opera
          el.webkitRequestFullscreen();
        } else if (el.msRequestFullscreen) { // IE/Edge
          el.msRequestFullscreen();
        }
      } else if (doc.exitFullscreen) {
        doc.exitFullscreen();
      } else if (doc.mozCancelFullScreen) {
        doc.mozCancelFullScreen();
      } else if (doc.webkitExitFullscreen) {
        doc.webkitExitFullscreen();
      } else if (doc.msExitFullscreen) {
        doc.msExitFullscreen();
      }
    },
    async doRefreshAggregation() {
      if (!this.activeOrderId) {
        return;
      }

      this.refreshAggregationLoading = true;
      const { plantCode } = this.globalSettings;
      try {
        await this.refreshAggregation({
          params: {
            plantCode,
            query: {
              orderId: this.activeOrderId,
            },
          },
        });
      } finally {
        this.refreshAggregationLoading = false;
      }
    },
    async fetchProdOrderForSelectedLine(silent = false) {
      this.loadingActiveLineOrders = !silent;
      const { data } = await this.getProdOrders({
        params: {
          query: {
            lineId: this.selectedLineId,
          },
        },
      });
      if (JSON.stringify(data) !== JSON.stringify(this.activeLineOrders)) {
        this.activeLineOrders = data;
      }

      this.loadingActiveLineOrders = false;
    },
    handleSelectOrder() {
      this.offcanvasVisible = CockpitOffcanvasTypes.ORDER_DETAILS;
    },
    handleSelectQueueItem(item) {
      this.showLoadingOverlay = true;
      this.selectedLabelArchiveId = item.id;
      this.offcanvasUnit = item.unitId;
      this.offcanvasVisible = CockpitOffcanvasTypes.QUEUE_ITEM_DETAILS;
      this.offcanvasTabIndex = 0;
      this.showLoadingOverlay = false;
    },
    handleSelectPrintManually() {
      this.offcanvasVisible = CockpitOffcanvasTypes.PRINT_MANUALLY;
    },
    handleAuditButtonClicked() {
      this.offcanvasVisible = CockpitOffcanvasTypes.QUEUE_ITEM_AUDIT;
    },
    handleBackButtonClicked() {
      this.offcanvasVisible = CockpitOffcanvasTypes.QUEUE_ITEM_DETAILS;
    },
    handleOpenOperations() {
      this.offcanvasVisible = CockpitOffcanvasTypes.QUEUE_ITEM_OPERATIONS;
    },
    async fetchLabelArchiveBySerialNumber(serialNumber) {
      const { plantCode } = this.globalSettings;
      return this.getLabelArchiveByBarcodes({
        params: {
          plantCode,
          query: {
            exactBarCodes: [serialNumber],
          },
        },
      });
    },
    async handleClickEnter() {
      if (!this.scannedSerialNumber) return;
      if (this.showLoadingOverlay) return;

      this.$bvToast.hide();
      const scanned = this.scannedSerialNumber.trim();
      this.scannedSerialNumber = '';
      this.showLoadingOverlay = true;
      const { data } = await this.fetchLabelArchiveBySerialNumber(scanned);
      const id = data[0]?.id;
      if (id) {
        this.handleSelectQueueItem(data[0]);
      } else {
        this.$bvToast.toast(`Zeskanowanego kodu nie ma w systemie (${scanned}).`, {
          title: 'Nie znaleziono kodu!',
          variant: 'warning',
          solid: true,
          toaster: 'b-toaster-bottom-left',
        });
      }
      this.showLoadingOverlay = false;
    },
    handleKeyDown(event) {
      if (
        this.offcanvasVisible === CockpitOffcanvasTypes.QUEUE_ITEM_DETAILS
        && this.offcanvasTabIndex === 1
      ) return;

      if (event.key === 'Enter' || event.key === 'NumpadEnter' || event.key === '\r') {
        this.handleClickEnter();
      } else {
        const isNumber = /^[0-9]$/;
        const isLetter = /^[A-Za-z]$/;
        const isSemiColon = /^;$/;
        const isSpecial = /^[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+$/;
        const isDash = /^-$/;
        if (
          isNumber.test(event.key)
          || isLetter.test(event.key)
          || isSemiColon.test(event.key)
          || isDash.test(event.key)
          || isSpecial.test(event.key)
        ) {
          this.scannedSerialNumber += event.key;
        }
      }
    },
    initKeyDownListener() {
      document.addEventListener(
        'keydown',
        this.handleKeyDown,
      );
    },
    removeKeyDownListener() {
      document.removeEventListener(
        'keydown',
        this.handleKeyDown,
      );
    },
    handleOperationSuccess() {
      this.offcanvasVisible = CockpitOffcanvasTypes.QUEUE_ITEM_DETAILS;
    },
    initRefreshInterval() {
      this.cockpitOrderRefreshInterval = setTimeout(async () => {
        await this.fetchProdOrderForSelectedLine(true);
        this.initRefreshInterval();
      }, 5000);
    },
    removeRefreshInterval() {
      clearInterval(this.cockpitOrderRefreshInterval);
    },
    hideSidebar() {
      const sidebar = document.querySelector('.sidebar');
      if (!sidebar) return;
      sidebar.style.display = 'none';
    },
    showSidebar() {
      const sidebar = document.querySelector('.sidebar');
      if (!sidebar) return;
      sidebar.style.display = 'block';
    },
    goToOrders() {
      this.$router.push('/orders');
    },
    handleShowPrintBatch(data) {
      this.printBatchFormData = data;
      this.showPrintBatchesModal = true;
    },
  },
  async created() {
    const { plantCode } = this.globalSettings;
    this.selectedLineId = this.defaultLineId;

    if (!this.selectedLineId) return;
    this.initLoading = true;
    this.initKeyDownListener();
    this.initRefreshInterval();
    await this.getUnits({
      params: {
        plantCode,
      },
    });
    await this.getPackingSettings({
      params: {
        plantCode,
      },
    });
    this.initLoading = false;
  },
  mounted() {
    this.hideSidebar();
  },
  beforeDestroy() {
    this.removeRefreshInterval();
    this.removeKeyDownListener();
    this.showSidebar();
  },
};
</script>

<template>
  <BOverlay :show="showLoadingOverlay">
    <div
      v-if="!selectedLineId"
      class="cockpit-root"
    >
      <div class="cockpit-wrapper">
        <div class="no-active-order-info flex-column">
          <div class="d-flex align-items-center justify-content-center mb-3">
            <i class="fas fa-info-circle" />
            Brak wybranej linii
          </div>

          <p
            class="text-body"
            style="font-size: 14px; opacity: 50%"
          >
            Preferencje > Preferowana linia
          </p>
        </div>
      </div>
    </div>
    <Loader v-else-if="initLoading" />
    <div v-else>
      <div class="cockpit-root">
        <CockpitLineVerticalSelector
          v-if="debug"
          v-model="selectedLineId"
          :lines-collapsed.sync="linesCollapsed"
        />

        <div class="cockpit-wrapper">
          <div class="d-flex justify-content-between align-items-center">
            <div
              class="d-flex justify-content-between align-items-center"
              style="gap: 0.5rem"
            >
              <BButton
                variant="outline-secondary"
                size="sm"
                @click="goToOrders"
              >
                <i class="fas fa-arrow-left mr-1" />
                Wyjdź z kokpitu
              </BButton>

              <BButton
                v-b-tooltip.hover.bottom="'Przełącz tryb pełnoekranowy'"
                variant="outline-secondary"
                size="sm"
                class="btn-circle d-flex align-items-center justify-content-center"
                @click="toggleFullscreen"
              >
                <i
                  class="fas fa-fw fa-expand"
                  style="font-size: 14px;"
                />
              </BButton>
            </div>

            <BOverlay
              :show="refreshAggregationLoading"
              spinner-variant="primary"
              spinner-type="grow"
            >
              <div
                class="btn btn-outline-success btn-sm"
                @click="doRefreshAggregation"
              >
                <i class="fas fa-refresh mr-1" />
                Odśwież agregację
              </div>
            </BOverlay>
          </div>

          <div
            v-if="loadingActiveLineOrders"
            class="loading"
          >
            <Loader />
          </div>

          <div
            v-if="!loadingActiveLineOrders && !activeLineOrders.length"
            class="no-active-order-info"
          >
            <div class="d-flex flex-column">
              <div class="d-flex align-items-center justify-content-center mb-3">
                <i class="fas fa-info-circle" />
                {{ $t('cockpit.noActiveOrder') }}
              </div>
            </div>
          </div>

          <CockpitActiveOrderCard
            v-if="activeLineOrders[0] && !loadingActiveLineOrders && !debug"
            :active-orders="activeLineOrders"
            @select-order="handleSelectOrder"
          />

          <div
            v-if="debug"
            class="d-flex justify-content-between"
          >
            <BButtonGroup>
              <BButton
                v-for="status in allStatuses"
                :key="status.id"
                style="font-size: 12px;"
                size="sm"
                :variant="debugStatuses.includes(status.id) ? 'primary' : 'secondary'"
                @click="debugStatuses.includes(status.id)
                  ? debugStatuses.splice(debugStatuses.indexOf(status.id), 1)
                  : debugStatuses.push(status.id)"
              >
                {{ status.name }}
              </BButton>
            </BButtonGroup>
          </div>

          <CockpitMatryoshka
            v-if="activeLineOrders[0] && !loadingActiveLineOrders"
            :key="matrioshkaKey"
            :selected-line-id="selectedLineId"
            :active-order="activeLineOrders[0]"
            :active-orders="activeLineOrders"
            :lines-collapsed="linesCollapsed"
            :debug-statuses="debugStatuses"
            @show-print-batch="handleShowPrintBatch"
            @select-item="handleSelectQueueItem"
            @print-manually="handleSelectPrintManually"
          />
        </div>
      </div>

      <CockpitOffcanvas
        :show="!!offcanvasVisible"
        :tabs-key="offcanvasVisible || ''"
        :tab-index.sync="offcanvasTabIndex"
        :tabs="offcanvasTabs"
        :icon="offcanvasIcon"
        :show-audit-button="
          offcanvasVisible === CockpitOffcanvasTypes.QUEUE_ITEM_DETAILS"
        :show-back-button="
          offcanvasVisible === CockpitOffcanvasTypes.QUEUE_ITEM_OPERATIONS
            || offcanvasVisible === CockpitOffcanvasTypes.QUEUE_ITEM_AUDIT
        "
        @audit-button-clicked="handleAuditButtonClicked"
        @back-button-clicked="handleBackButtonClicked"
        @update:show="offcanvasVisible = $event"
      >
        <template #title>
          <div class="d-flex align-items-center">
            <LabelArchiveMatrix
              v-if="offcanvasVisible === CockpitOffcanvasTypes.QUEUE_ITEM_DETAILS"
              :label-archive-id="selectedLabelArchiveId"
              class="mr-1"
              width="45px"
              height="45px"
            />

            {{ offcanvasTitle }}
          </div>
        </template>
        <template #default>
          <BOverlay
            :show="showLoadingOverlay"
            class="h-100"
          >
            <!--    ACTIVE ORDER    -->
            <Loader v-if="loadingActiveLineOrders" />
            <CockpitActiveOrderDetailsTab
              v-if="
                offcanvasVisible === CockpitOffcanvasTypes.ORDER_DETAILS
                  && offcanvasTabIndex === 0
                  && !loadingActiveLineOrders
                  && activeLineOrders[0]
              "
              :active-order="activeLineOrders[0]"
              @refresh="fetchProdOrderForSelectedLine"
            />
            <CockpitActiveOrderHistoryTab
              v-if="
                offcanvasVisible === CockpitOffcanvasTypes.ORDER_DETAILS
                  && offcanvasTabIndex === 1
              "
              :active-order="activeLineOrders[0]"
            />

            <!--    MATRIOSZKA MANUAL PRINT    -->
            <CockpitMatryoshkaPrintManuallyTab
              v-if="
                offcanvasVisible === CockpitOffcanvasTypes.PRINT_MANUALLY
                  && offcanvasTabIndex === 0
              "
            />

            <!--    MATRIOSZKA    -->
            <CockpitMatryoshkaItemDetailsTab
              v-if="
                offcanvasVisible === CockpitOffcanvasTypes.QUEUE_ITEM_DETAILS
                  && offcanvasTabIndex === 0
              "
              :label-archive-id="selectedLabelArchiveId"
            />
            <CockpitMatryoshkaItemContentsTab
              v-if="
                offcanvasVisible === CockpitOffcanvasTypes.QUEUE_ITEM_DETAILS
                  && offcanvasTabIndex === 1
              "
              :order-id="activeOrderId"
              :label-archive-id="selectedLabelArchiveId"
              @go-to-serial-number="handleSelectQueueItem"
            />
            <CockpitMatryoshkaItemHistoryTab
              v-if="
                offcanvasVisible === CockpitOffcanvasTypes.QUEUE_ITEM_DETAILS
                  && offcanvasTabIndex === 2
              "
              :label-archive-id="selectedLabelArchiveId"
            />
            <CockpitMatryoshkaItemLabelTab
              v-if="
                offcanvasVisible === CockpitOffcanvasTypes.QUEUE_ITEM_DETAILS
                  && offcanvasTabIndex === 3
              "
              :label-archive-id="selectedLabelArchiveId"
            />

            <!--    MATRIOSZKA OPERATIONS    -->
            <CockpitMatryoshkaItemOperationsTab
              v-if="offcanvasVisible === CockpitOffcanvasTypes.QUEUE_ITEM_OPERATIONS
                && offcanvasTabIndex === 0"
              :label-archive-id="selectedLabelArchiveId"
              @operation-success="handleOperationSuccess"
            />

            <!--    MATRIOSZKA AUDIT    -->
            <CockpitMatryoshkaItemAuditTab
              v-if="offcanvasVisible === CockpitOffcanvasTypes.QUEUE_ITEM_AUDIT
                && offcanvasTabIndex === 0"
            />
          </BOverlay>
        </template>

        <template #actions>
          <!--    MATRIOSZKA    -->
          <CockpitMatryoshkaItemActionButtons
            v-if="
              offcanvasVisible === CockpitOffcanvasTypes.QUEUE_ITEM_DETAILS
                && offcanvasTabIndex === 0
            "
            @open-operations="handleOpenOperations"
          />
        </template>
      </CockpitOffcanvas>
    </div>

    <PrintBatchesModal
      :show="showPrintBatchesModal"
      :data="printBatchFormData"
      @update:show="showPrintBatchesModal = $event"
    />
  </BOverlay>
</template>

<style scoped lang="scss">
.cockpit-root {
  display: flex;
  position: relative;
  height: calc(100vh - 60px + 1rem);
  width: calc(100% + 3rem);
  margin: -1rem -1.5rem;
  overflow-y: auto;

  .cockpit-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    justify-content: center;
    background-color: #F6F6F6;
    border-right: 1px solid #ECECEC;
    padding: 1.5rem 1rem 1rem 1rem;
    gap: 12px;
  }

  .no-active-order-info {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80%;
    font-size: 24px;
    font-weight: 500;
    color: #888888;

    i {
      margin-right: 8px;
    }
  }
}
</style>
